export class VitalComparisonReport {
    FacilityName: string;
    CorporateLocation: string;
    FacilityId: string;
    PatientCount: number;
    Week0: number;
    Week1: number;
    Week2: number;
    Week3: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/reports.ts